import { inApp, callHandlerToNative } from '@hst/utils';
import { jumpTransferPage, jumpPathPageByWindow } from 'src/utils/jump';
import { getLang } from 'src/utils/lang';

export function getAccWebApiDomain() {
	const map = {
		dev: '/api',
		feature: 'https://web-api-feature.mplusglobal.com.my',
		daily: 'https://web-api-daily.global.mplusonline.com',
		uat: 'https://web-api-uat.global.mplusonline.com',
		beta: 'https://web-api-beta.global.mplusonline.com',
		prod: 'https://web-api.global.mplusonline.com',
	};
	return map[process.env.REACT_APP_ENV];
}

export function getBaseApiDomain() {
	const map = {
		dev: '/api',
		feature: 'https://web-api-feature.mplusglobal.com.my',
		daily: 'https://web-api-daily.mplusglobal.com.my',
		uat: 'https://web-api-uat.mplusglobal.com.my',
		beta: 'https://web-api-beta.mplusglobal.com.my',
		prod: 'https://web-api.global.mplusonline.com',
	};
	return map[process.env.REACT_APP_ENV];
}

/**
 * 兑换失败类型枚举
 * https://e5mgsch64p.feishu.cn/sheets/WqjMsRDWPh7mXatPGqDcEOpKndO?sheet=bjM6wi
 */
export const FailTypeEnum = {
	/** 1: sdk 不存在 */
	SDK_ABSENT: 1,
	/** 2: sdk 非上线状态 */
	SDK_INVALID: 2,
	/** 3: 兑换码未开始 */
	CODE_NOT_STARTED: 3,
	/** 4: 兑换码已结束 */
	CODE_ENDED: 4,
	/**
	 * 5: 单兑换码参与达上线
	 * 单个用户每个兑换码只能兑现一次
	 */
	SINGLE_CODE_LIMIT: 5,
	/**
	 * 6: 多兑换码参与达上线
	 * 单个用户每天最多兑换 5 次不同兑换码
	 */
	MULTI_CODE_LIMIT: 6,
	/** 7: sdk 兑换数量限制 */
	SDK_COUNT_LIMIT: 7,
	/** 8: sdk 用户类型限制 */
	USER_TYPE_LIMIT: 8,
	/** 9: sdk 渠道限制 */
	CHANNEL_LIMIT: 9,
	/** 10: 兑换码 id 互斥 */
	CODE_ID_MUTEX: 10,
	/** 11: 兑换码业务类别互斥 */
	CODE_BUZ_TYPEMUTEX: 11,
	/** 12: 兑换码业务异常（兜底） */
	REDEMPTION_SYSTEM_ERROR: 12,
};

export const URLS = {
	/** 帮助中心 H5 */
	Help: {
		prod: 'https://m.global.mplusonline.com/h5/help/help/details/1000892',
		feature: 'https://m-feature.mplusglobal.com.my/h5/help/help/details/1000940',
	},
	/** 我的卡券 H5 */
	Coupon: {
		prod: 'https://m.global.mplusonline.com/m/coupon',
		feature: 'https://m-feature.mplusglobal.com.my/m/coupon',
	},
	/** 兑换历史记录 H5 */
	Redeem: {
		prod: 'https://mobi.mplusonline.com/activities/redemptions/record',
		feature: 'https://mobi-feature.mplusglobal.com.my/activities/redemptions/record',
	},
	/** 登录 H5 */
	Login: {
		prod: 'https://global.mplusonline.com/passport/login',
		feature: 'https://feature.mplusglobal.com.my/passport/login',
	},
};

/**
 *
 * @param {*} url h5链接
 * @param {*} params h5携带参数
 * @param {
 * * isToTransferPage: 是否唤起中转页
 * * isLogin: 是否跳转到登录页
 * * isBack: 是否携带target，返回链接
 * } otherArgs 其他变量
 */
export function jumpToH5(url, params = {}, otherArgs: any = {}) {
	const newUrl = `${url}?${new URLSearchParams(params).toString()}`;
	const { isToTransferPage = false, isLogin = false, isBack = false } = otherArgs;
	if (inApp()) {
		if (isLogin) {
			// 登录桥接
			callHandlerToNative({
				type: 'LOGIN',
				data: {
					needPop: 'n', // IOS，关闭登录，是否需要返回上一页
					url: location.href,
				},
			});
		} else {
			// 其他h5页面打开桥接
			callHandlerToNative({
				redirectType: 1,
				redirectValue: {
					url: newUrl,
				},
			});
		}
		return;
	} else if (isToTransferPage) {
		jumpTransferPage(getLang(), {
			redirectType: '1',
			redirectValue: {
				url: newUrl,
				...params,
			},
		});
		return;
	}
	const otherParams = isBack
		? {
				target: location.href,
			}
		: {};
	jumpPathPageByWindow(newUrl, otherParams);
}
